import { deserialize, list, object, optional, serializable } from 'serializr';

export class MantisCategoryModel {
  @serializable
  public id: string;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(MantisCategoryModel, input));
  }
}

export class MantisProjectModel {
  @serializable
  public id: string;
  @serializable
  public name: string;

  @serializable(list(object(MantisCategoryModel)))
  public categories: MantisCategoryModel[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(MantisProjectModel, input));
  }
}

export class MantisIssueModel {
  @serializable
  public id: string;
  @serializable
  public summary: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(MantisIssueModel, input));
  }
}
